import request from '@/utils/request'

export function selectOrderDelivery(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderManagement/selectOrderDelivery?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}


export function selectOrderDeliveryType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderManagement/selectOrderDeliveryType`,
        method: 'post',
        data,
    })
}


export function downLoadOrderDelivery(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadOrderDelivery`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }